<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';
    import { sgettext } from "../../../i18n.js";

    export let row = { id: null, activity_version: null };
    // {% url 'builder:builder:activity-version-task-list-operations' row.activity_version %}
    $: url = `${PATH_PREFIX}/sw/builder/activityversion/task-list-operations/${row.activity_version}/?task_list_configuration=${row.id}`;
    export let linkText = sgettext("$$MAP_OPERATIONS$$");

    let fontColor = "color:red;";

</script>

{#if row.unmapped_sequences}
    <a
        href={url}
        class="dropdown-item"
        target="_blank"
        rel="noopener noreferrer"
        title={sgettext("$$CONFIGURATION_UNMAPPED_OPERATIONS$$")}
        style={fontColor}
        ><i class="fas fa-sitemap fa-rotate-90 fa-fw"></i>{linkText} ({row.unmapped_sequences})</a>
{:else}
    <a href={url} class="dropdown-item" target="_blank" rel="noopener noreferrer"><i class="fas fa-sitemap fa-rotate-90 fa-fw"></i> {linkText}</a>
{/if}
